export default class ActividadProxi {
    constructor(axios, url) {
        this.axios = axios;
        this.url = url;
    }
    //-----------------------------------PUNTOS DE ATERRISAJE FOROS GENERAL-------------------------

    publishOne(id, params) {
        return this.axios.put(this.url + `/foros/publishOne/${id}`, params);
    }
    publishTwo(id, params) {
        return this.axios.put(this.url + `/foros/publishTwo/${id}`, params);
    }
    clickLike(id, params) {
        return this.axios.put(this.url + `/foros/clickLike/${id}`, params);
    }
    clickNoLike(id, params) {
        return this.axios.put(this.url + `/foros/clickNoLike/${id}`, params);
    }
    removeLike(id, params) {
        return this.axios.put(this.url + `/foros/removeLike/${id}`, params);
    }
    removeNoLike(id, params) {
        return this.axios.put(this.url + `/foros/removeNoLike/${id}`, params);
    }
    removeForoOne(id, params) {
        return this.axios.put(this.url + `/foros/removeForoOne/${id}`, params);
    }
    removeForoTwo(id, params) {
        return this.axios.put(this.url + `/foros/removeForoTwo/${id}`, params);
    }

}